import { j as jsxRuntimeExports } from './jsx-runtime-D2XkDcqR.js';

const MixpanelTracking = ({ id, ...config }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  id ? /* @__PURE__ */ jsxRuntimeExports.jsx("script", { async: true, src: getScriptSrc() }) : null,
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "script",
    {
      dangerouslySetInnerHTML: {
        __html: getScriptInit(id, config)
      }
    }
  )
] });
const getScriptSrc = () => "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
const getScriptInit = (id, config) => [
  `window.mixpanel=[]`,
  `mixpanel._i=[]`,
  `mixpanel.__SV=1.2`,
  `mixpanel.people=[]`,
  `mixpanel.toString=e=>e?"mixpanel":"mixpanel (stub)"`,
  `mixpanel.people.toString=()=>mixpanel.toString(!0)+".people (stub)"`,
  `mixpanel.init=(e,t)=>{const p=(e,t)=>{const p=t.split(".");2===p.length&&(e=e[p[0]],t=p[1]),e[t]=(...p)=>{e.push([t].concat(p))}},n=["disable","time_event","track","track_pageview","track_links","track_forms","track_with_groups","add_group","set_group","remove_group","register","register_once","alias","unregister","identify","name_tag","set_config","reset","opt_in_tracking","opt_out_tracking","has_opted_in_tracking","has_opted_out_tracking","clear_opt_in_out_tracking","start_batch_senders","people.set","people.set_once","people.unset","people.increment","people.append","people.union","people.track_charge","people.clear_charges","people.delete_user","people.remove"];for(const e of n)p(mixpanel,e);const o=["set","set_once","union","unset","remove","delete"];mixpanel.get_group=(...e)=>{const t={};for(const p of o)t[p]=(...t)=>{mixpanel.push([["get_group",...e],[p,...t]])};return t},mixpanel._i.push([e,t,"mixpanel"])}`,
  `mixpanel.init(${JSON.stringify(id)},${JSON.stringify(config)})`
].join(";");

export { MixpanelTracking };
